import styled, { css } from 'styled-components';

export const MutedMessage = styled.div`
  position: fixed;
  top: 3.2rem;
  transform: translate(-50%);
  font-size: 0.9rem;
  border-radius: ${(props) => props.theme.borderRadius.md};
  background-color: ${(props) => props.theme.color.primaryDark};
  color: ${(props) => props.theme.color.contrast.primaryDark};
  padding: 0.5rem 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  left: 50%;
`;
